import type { HitResultItem } from 'vue-instantsearch/vue3/es';

export const calculateHitResultProductDiscount = (product : HitResultItem) => {

  return product.basePrice && product.price && product.basePrice > product.price
    ? product.basePrice - product.price
    : 0;

};
